import { Auth, API } from "aws-amplify";

async function saveConfig(config) {
  return API.post("prod-slippy", "/config", {
    headers: {
      Authorization: `Bearer ${(await Auth.currentSession())
        .getIdToken()
        .getJwtToken()}`
    },
    body: {
      config
    }
  });
}

async function disableBookie(bot, bookie, reason) {
  debugger;

  return API.post("prod-slippy", "/config/bookie/disable", {
    headers: {
      Authorization: `Bearer ${(await Auth.currentSession())
        .getIdToken()
        .getJwtToken()}`
    },
    body: {
      bot,
      bookie,
      reason
    }
  });
}


async function readConfig() {
  return API.get("prod-slippy", "/config", {
    headers: {
      Authorization: `Bearer ${(await Auth.currentSession())
        .getIdToken()
        .getJwtToken()}`
    }
  });
}

export { saveConfig, readConfig, disableBookie };
